<h3 mat-dialog-title>Event Edit</h3>
<mat-dialog-content style="height: calc(100% - 100px);">

    <div *ngFor="let item of this.data.row">
        <!-- String -->
        <ng-container *ngIf="getType(item)=='string'">
        <label matLab>{{item["label"]?item["label"]:item["name"]}}<span style="color:red">{{item["isRequired"]?"*":""}}</span></label>
        <input matInput type="text" class="aip-input" [(ngModel)]="this.data.data.data[item['name']]['newtext']"/>
        </ng-container>

        <!-- WYSYWIG quill editor -->
        <ng-container *ngIf="getType(item)=='formattedtext'">
            <label matLab>{{item["label"]?item["label"]:item["name"]}}<span style="color:red">{{item["isRequired"]?"*":""}}</span></label>
                            
            <quill-editor [modules]="quillModules" (onEditorCreated)='editorInit($event)'
            [styles]="{height:(item['height']? item['height'] : '90px')}" [(ngModel)]="this.data.data.data[item['name']]['newtext']"></quill-editor>  
            
        </ng-container>

        <!-- Break -->
        <ng-container *ngIf="getType(item)=='break'">
            <mat-divider></mat-divider>
        </ng-container>

        <!-- Header -->
        <ng-container *ngIf="getType(item)=='header'">
            <div class="header back-grey">
            {{item["label"]?item["label"]:""}}
            <mat-divider></mat-divider>
            </div>
        </ng-container>

        <!-- Date -->
        <ng-container *ngIf="getType(item)=='date'">
            <label matLab>{{item["label"]?item["label"]:item["name"]}}<span style="color:red">{{item["isRequired"]?"*":""}}</span></label>
            <mat-form-field appearance="fill" style="width:100%" (click)="picker.open()">
                <input matInput [matDatepicker]="picker" (click)="picker.open()" [formControl]="date" [(ngModel)]="this.data.data.data[item['name']]['newtext']">
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
        </ng-container>
    </div>   

</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-raised-button color="primary" class="aip-button" (click)="save()" cdkFocusInitial>OK</button>    
    <button mat-raised-button class="aip-button-alt" (click)="close()">Cancel</button>
</mat-dialog-actions>


<!-- Overlay for the dropdowns -->
<div id="selectOverlayDiv" #selectOverlay class="aip-select-overlay" style="position: absolute;"></div>